import { useEffect, useRef, useState, useCallback } from 'react';
import CountUp from 'react-countup';

export default function AnimatedCounter({ end, suffix = '', prefix = '', duration = 2.5, label }) {
  const nodeRef = useRef(null);
  const [inView, setInView] = useState(false);

  const handleIntersection = useCallback((entries) => {
    const [entry] = entries;
    if (entry.isIntersecting) setInView(true);
  }, []);

  useEffect(() => {
    const node = nodeRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(handleIntersection, { threshold: 0.3 });
    observer.observe(node);

    return () => observer.disconnect();
  }, [handleIntersection]);

  return (
    <div ref={nodeRef} data-testid={`stat-${label?.toLowerCase().replace(/\s+/g, '-')}`}>
      {inView ? (
        <CountUp end={end} suffix={suffix} prefix={prefix} duration={duration} separator="," />
      ) : (
        <span>{prefix}0{suffix}</span>
      )}
    </div>
  );
}
